export const WEEKDAY_OPTIONS = [
  { value: 1, label: 'Lunedi', short: 'Lun' },
  { value: 2, label: 'Martedi', short: 'Mar' },
  { value: 3, label: 'Mercoledi', short: 'Mer' },
  { value: 4, label: 'Giovedi', short: 'Gio' },
  { value: 5, label: 'Venerdi', short: 'Ven' },
  { value: 6, label: 'Sabato', short: 'Sab' },
  { value: 0, label: 'Domenica', short: 'Dom' },
];

export const DEFAULT_WEEKDAY_AVAILABILITY = WEEKDAY_OPTIONS.map((day) => day.value);

export const normalizeAvailableWeekdays = (value) => {
  const values = Array.isArray(value) ? value : DEFAULT_WEEKDAY_AVAILABILITY;

  const normalized = values
    .map((entry) => Number(entry))
    .filter((entry) => Number.isInteger(entry) && entry >= 0 && entry <= 6);

  const uniqueSorted = Array.from(new Set(normalized)).sort((a, b) => a - b);
  return uniqueSorted.length > 0 ? uniqueSorted : [...DEFAULT_WEEKDAY_AVAILABILITY];
};

export const getRomeWeekday = () => {
  const shortDay = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Europe/Rome',
    weekday: 'short',
  }).format(new Date());

  const weekdayMap = {
    Sun: 0,
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6,
  };

  return weekdayMap[shortDay] ?? 1;
};

export const formatWeekdayAvailabilityLabel = (weekdays) => {
  const normalized = normalizeAvailableWeekdays(weekdays);

  if (normalized.length === DEFAULT_WEEKDAY_AVAILABILITY.length) {
    return 'Tutti i giorni';
  }

  return WEEKDAY_OPTIONS
    .filter((day) => normalized.includes(day.value))
    .map((day) => day.short)
    .join(', ');
};
